const FeaturedArticles = function () {
    const containers = document.querySelectorAll( '.featured-articles' );
    containers.forEach( function( container ){
        const data = container.dataset;
        const articleContainer = container.querySelector( '[data-article-container]' );
        // if there are tags on the dataset, we need to get this through ajax
        if( typeof( data.tags ) !== 'undefined'){
            const url = data.url.replace( 'tags' , data.tags  );
            fetch( url )
            .then( res => {
                if( res.ok ){
                    return res.text();
                }
                return false;
            })
            .then( text => {
                if( text ){
                    // container.classList.remove( 'd-none');
                    articleContainer.innerHTML = text;
                }else{
                    container.parentNode.removeChild( container )
                }
            })
        }
    });
}
  
export default FeaturedArticles